import React from 'react'
import MainContentSubAccessories from '../MainContentSubAccessories'

const ProjectorSub = () => {
  return (
    <div className='pageAccessories bg-accessories-sub-page'>
        <MainContentSubAccessories parentCate={'Thiết bị nhà thông minh'}  
            childCate={'Máy chiếu'} 
            // listProduct={listProductSub}
    />
</div>
  )
}

export default ProjectorSub
